import './App.css';
import { useMemo } from 'react';
import * as anchor from '@project-serum/anchor';
import Home from './Home';

import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from '@solana/wallet-adapter-wallets';

import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';
import { WalletDialogProvider } from '@solana/wallet-adapter-material-ui';

import { ThemeProvider, createTheme } from '@material-ui/core';

const theme = createTheme({
  palette: {
    type: 'dark',
  },
});

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    const candyMachineId = new anchor.web3.PublicKey(
      process.env.REACT_APP_CANDY_MACHINE_ID!,
    );

    return candyMachineId;
  } catch (e) {
    console.log('Failed to construct CandyMachineId', e);
    return undefined;
  }
};

const candyMachineId = getCandyMachineId();
const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost
  ? rpcHost
  : anchor.web3.clusterApiUrl('devnet'));

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);
const txTimeoutInMilliseconds = 30000;

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSlopeWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [],
  );

  return (
    <div>

      <h1
        style={{
          fontSize: "4rem",
          color: "#f7c624",
          textAlign: "center",
          marginTop: "4rem",
          fontFamily: "Inter,sans-serif",
          fontWeight: "800",
          marginBottom: "0"
        }}
      >DOWN UNDER</h1>

      <div
        style={{
          fontSize: "2rem",
          color: "#f7c624",
          textAlign: "center",
          fontFamily: "Inter,sans-serif",
          fontWeight: "800",
        }}
      >Victoria Mint</div>

    <ThemeProvider theme={theme}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletDialogProvider>
            <Home
              candyMachineId={candyMachineId}
              connection={connection}
              startDate={startDateSeed}
              txTimeout={txTimeoutInMilliseconds}
              rpcHost={rpcHost}
            />
          </WalletDialogProvider>
        </WalletProvider>
      </ConnectionProvider>
    </ThemeProvider>

    <div className='imgContainer'>
      <img src="https://arweave.net/lHZOVPqpIg9TWLo9JmNoeHYkr0J_uQl3fQZO5UEEe00?ext=gif" alt="" />
      <img src="https://wqtrl6bsoiv6euhl7r6u25e5oxncq7fxvffml2ypynq6ydd4xjxq.arweave.net/tCcV-DJyK-JQ6_x9TXSdddoofLepSsXrD8Nh7Ax8um8/?ext=gif" alt="" />
      <img src="https://xr6tjalapakttgwap3z22tfem7jmgcmjupgv72plo7bepw4oyksa.arweave.net/vH00gWB4FTmawH7zrUykZ9LDCYmjzV_p63fCR9uOwqQ/?ext=gif" alt="" />
      <img src="https://arweave.net/3DmNKTvZPBareFR-RD695mklSEv-8RULiDyRW0pLTsE?ext=gif" alt="" />
      <img src="https://arweave.net/x0J4DQ7pVD7RT7IrBaSNFwZsdxrkqOgveubjsQjeRJI?ext=gif" alt="" />
      <img src="https://arweave.net/WdhTb9ssbAACw7BtKa9BNW3BQnpUjPUdRZLMWauZ9vg?ext=gif" alt="" />
      <img src="https://arweave.net/IKxruZ4PSHMEBNXOeoZYsqQrq3hPwHNBLsE1yGp8CHY?ext=gif" alt="" />
      <img src="https://arweave.net/ATH_IBYJT7UVceNJEy6Vx27tazxC7S8Tt14u_ciNa64?ext=gif" alt="" />
    </div>



    </div>
  );
};

export default App;
